const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export async function submitContactForm({ captchaToken, ...formData }) {
  const response = await fetch(`${API_BASE_URL}/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...formData,
      captchaToken: captchaToken || undefined,
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.error || 'Unable to send your message. Please try again.');
  }

  return payload;
}
